"use strict";
/**
 *
 * SvgIcon
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("../styles");
const styles = {
    root: {
        fill: 'currentColor',
        width: '1em',
        height: '1em',
        flexShrink: 0,
        display: 'inline-block',
        fontSize: 24,
    },
};
exports.svgIconClassName = styles_1.generateStaticClassName('SvgIcon');
const SvgIcon = React.forwardRef(function SvgIcon(props, ref) {
    const { children, classes, className } = props, rest = __rest(props, ["children", "classes", "className"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24" }, rest, { className: clsx_1.default(exports.svgIconClassName, classes.root, className), ref: ref }), children));
});
if (process.env.NODE_ENV !== 'production') {
    SvgIcon.displayName = 'SvgIcon';
}
const StyledSvgIcon = styles_1.withStyles(styles)(SvgIcon);
exports.SvgIcon = StyledSvgIcon;
